import { AxiosInstance } from 'axios';
import {
  Address,
  BpOrderLine,
  BpOrdersResponse,
  BusinessPartner,
  BusinessPartnerWithStats,
  SalesPerson,
  ShippingType,
} from '@/api/business-partner/business-partner.types.ts';
import { Item } from '@/api/items/items.types.ts';
import { ContactEmployee, ContactEmployeeWithUser } from '@/api/contact-employee/contact-employee.types.ts';

export const createBusinessPartnersApi = (api: AxiosInstance) => ({
  getAllBusinessPartners: () =>
    api.get<BusinessPartner[]>('/v1/business-partners'),

  getAllBusinessPartnersWithOrderStats: () =>
    api.get<BusinessPartnerWithStats[]>('/v1/business-partners/with-order-stats'),

  getOrdersByBusinessPartnerId: (bpId: number, limit = 50, offset = 0) =>
    api.get<BpOrdersResponse>(
      `/v1/business-partners/${bpId}/orders?limit=${limit}&offset=${offset}`,
    ),

  getBusinessPartnerById: (id: number) =>
    api.get<BusinessPartner>(`/v1/business-partners/${id}`),

  getAddressByBusinessPartnerId: (
    businessPartnerId: number,
    addressId: string,
  ) =>
    api.get<Address>(
      `/v1/business-partners/${businessPartnerId}/addresses/${addressId}`,
    ),

  getAddressesByBusinessPartnerId: (businessPartnerId: number) =>
    api.get<Address[]>(`/v1/business-partners/${businessPartnerId}/addresses`),

  getSalesPersonByBusinessPartnerId: (businessPartnerId: number) =>
    api.get<SalesPerson | null>(
      `/v1/business-partners/${businessPartnerId}/sales-person`,
    ),

  getShippingTypesByBusinessPartnerId: (businessPartnerId: number) =>
    api.get<ShippingType[]>(
      `/v1/business-partners/${businessPartnerId}/shipping-types`,
    ),

  getItemsByBusinessPartnerId: (businessPartnerId: number) =>
    api.get<Item[]>(`/v1/business-partners/${businessPartnerId}/items`),

  getContactEmployeesByBusinessPartnerId: (businessPartnerId: number) =>
    api.get<ContactEmployee[]>(
      `/v1/business-partners/${businessPartnerId}/contact-employees`,
    ),

  getOrderLinesByDocEntry: (businessPartnerId: number, docEntry: number) =>
    api.get<BpOrderLine[]>(
      `/v1/business-partners/${businessPartnerId}/orders/${docEntry}/lines`,
    ),

  getContactEmployeesWithUserByBusinessPartnerId: (businessPartnerId: number) =>
    api.get<ContactEmployeeWithUser[]>(
      `/v1/business-partners/${businessPartnerId}/contact-employees-with-users`,
    ),

  getAllContactEmployees: () =>
    api.get<ContactEmployee[]>('/v1/contact-employees'),

  getContactEmployeeById: (
    businessPartnerId: number,
    contactEmployeeId: number,
  ) =>
    api.get<ContactEmployee>(
      `/v1/business-partners/${businessPartnerId}/contact-employees/${contactEmployeeId}`,
    ),

  syncBusinessPartners: () => api.post('/business-partners/sync'),
});
